module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/ultra-hd-web-065cf80b4fc33d7fc2c04cc0df796a8b.png";